var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconDownload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99995 1.4502C8.44178 1.4502 8.79995 1.80837 8.79995 2.2502V8.70391L11.2148 6.53056C11.5432 6.23499 12.049 6.26162 12.3446 6.59002C12.6402 6.91843 12.6135 7.42426 12.2851 7.71983L8.53512 11.0948C8.23088 11.3687 7.76902 11.3687 7.46478 11.0948L3.71478 7.71983C3.38637 7.42426 3.35975 6.91843 3.65532 6.59002C3.95088 6.26162 4.45671 6.23499 4.78512 6.53056L7.19995 8.70391V2.2502C7.19995 1.80837 7.55812 1.4502 7.99995 1.4502ZM1.99995 10.5752C2.44178 10.5752 2.79995 10.9334 2.79995 11.3752V12.5002C2.79995 12.8868 3.11335 13.2002 3.49995 13.2002H12.5C12.8866 13.2002 13.2 12.8868 13.2 12.5002V11.3752C13.2 10.9334 13.5581 10.5752 14 10.5752C14.4418 10.5752 14.8 10.9334 14.8 11.3752V12.5002C14.8 13.7705 13.7702 14.8002 12.5 14.8002H3.49995C2.2297 14.8002 1.19995 13.7705 1.19995 12.5002V11.3752C1.19995 10.9334 1.55812 10.5752 1.99995 10.5752Z",
    fill: "#71869D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadGray);
export default __webpack_public_path__ + "static/media/iconDownloadGray.4418008edc2bdaaea021738cd5042a4f.svg";
export { ForwardRef as ReactComponent };